module.exports = __webpack_public_path__ + "static/media/05.227e3aa5.JPG";